import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Shu',
    reviewText:
      'So thankful a friend recommended me to Zola! Best experience having a central space to keep my guest list and wedding day plans all in one place! T...',
    title: "Couldn't be happier!",
  },
  {
    name: 'Bryan',
    reviewText:
      'The Zola website is user friendly, visually appealing, and has so much to offer from website templates, guest list tracking, a whole stationery sui...',
    title: 'Helped us stay organized',
  },
  {
    name: 'Maryam',
    reviewText:
      'I got an email that save the dates were 50% off through Zola so I created one I liked. I ordered a proof in the mail so I can see if I like them. I...',
    title: 'Love the envelope addressing',
  },
];
